import { render } from "./NewAddress.vue?vue&type=template&id=40f57fae"
import script from "./NewAddress.vue?vue&type=script&lang=ts"
export * from "./NewAddress.vue?vue&type=script&lang=ts"
script.render = render

export default script